import { withStyles } from '@mui/styles';
import { compose } from 'recompose';
import { styles } from './review-item.styles';
import ReviewItem from './review-item';

export default compose(withStyles(styles))(ReviewItem);
